export const closest = (array: number[], num: number): number => array.reduce((a, b) => (Math.abs(a - num) < Math.abs(b - num) ? a : b));
